import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../../services/report.service';
import { Role} from '../../../models/User';
import { ChartReport } from '../../../models/Report';
import * as Constants from "../../../models/Constants";
import {ErisLoginService} from '../../../services/sso/eris-login.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  public roles: Role[]=[]
  reports: ChartReport[];
  chartReports: Array<ChartReport> = [];
  BarChartColours: any[] = [];
  chartLegend: boolean = true;
  appStatusBarChartColors : any[] = [{backgroundColor: ["#23c6c8", "#1569d9", "#21edf5", "#6724f6", "#9ed420", "#5a5504", "#4c6299", "#aff591", "#e2bdeb", "#7d5558",
                                                        "#a0a60b", "#ed5565", "#e1308c", "#1ab394", "#868f28", "#9949ba", "#6498bb", "#b69d41", "#805908", "#d9cf1a", 
                                                        "#f3a726", "#fe2769", "#bdd94c", "#5feef9", "#feda56", "#0c000e", "#6367f2"]}]

  constructor(private reportService: ReportService, private erisLoginService: ErisLoginService) {
  }

  ngOnInit() {

    this.reportService.getReportListByUser(this.erisLoginService.getUserId()).subscribe(
      resp=>{
        this.reports = resp;
        resp.forEach(report => {
          this.reportService.getChartReport(report.reportID).subscribe(
            resp=>{
            resp.labels =[];
            resp.values = [];
            resp.chartData = [];
            resp.chartColors = [];
            this.getExtraReportOptions(resp)
            this.chartReports.push(resp);
            this.chartReports.sort(function (a, b) {
              return a.priority - b.priority;   
            })
            
        
          })
          
        })
      
    })
    
    
  }

   getExtraReportOptions(reportData) {
    switch (reportData.reportType) {
      case Constants.PIE_CHART:
        reportData.chartType = Constants.PIECHART;
        if(reportData.title === Constants.FACILITY_GRADE){
          reportData.chartColors = [{backgroundColor: ["#FF7360", "#FFFF00", "#1AB394", "#EAF1F5"]}]
        }else if(reportData.title === Constants.FACILITY_BY_BRANCH){
          reportData.chartColors = [{backgroundColor: ["#8067DC", "#ffbc58", "#67B7DC", "#94F7F7", "#b6fcd5", "#a0db8e", "#d9a0c6"]}]
        }else if(reportData.title === Constants.FACILITY_COUNT){
          reportData.chartColors = [{backgroundColor: ["#8067DC", "#ffbc58", "#67B7DC", "#94F7F7", "#b6fcd5", "#a0db8e", "#d9a0c6", "#e13713", "#FFFF00"]}]
        }
        break;

      case Constants.BAR_CHART:
        this.BarChartColours = [];
        this.chartLegend = false;
        reportData.chartType = Constants.BARCHART;
        break;  

      case Constants.HORIZONTAL_BAR_CHART:
        if(reportData.title === Constants.COUNT_BY_STATUS_OF_APPS){
          reportData.chartColors = this.appStatusBarChartColors;
        }
        
        reportData.chartType = Constants.HORIZONTALBARCHART;
        break;      
  }

  reportData.data.forEach(e => {
    reportData.labels.push(e.name);
    reportData.values.push(e.value);
  })   

}
}